"use strict";

exports.__esModule = true;
exports.transformStakingLedger = transformStakingLedger;
var _sdkCore = require("@acala-network/sdk-core");
// FIXME: need remove this disable config

/* eslint-disable @typescript-eslint/no-unsafe-assignment */

function transformStakingLedger(data, stakingToken) {
  return data.map(item => {
    const key = item[0];
    const ledge = item[1].unwrapOrDefault();
    return {
      index: key.args[0].toNumber(),
      bonded: _sdkCore.FixedPointNumber.fromInner(ledge.bonded.unwrap().toString(), stakingToken.decimals),
      unlocking: ledge.unlocking.map(item => {
        return {
          value: _sdkCore.FixedPointNumber.fromInner(item.value.unwrap().toString(), stakingToken.decimals),
          era: item.era.unwrap().toNumber()
        };
      })
    };
  });
}